import { Modal as MaterialModal, SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';
import { ModalContainer } from './ModalStyle';

interface ModalProps extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
  sx?: SxProps<Theme>;
}
function Modal({ isOpen = false, onClose, children, sx }: ModalProps) {
  return (
    <div>
      <MaterialModal open={isOpen} onClose={onClose}>
        <ModalContainer sx={sx}>{children}</ModalContainer>
      </MaterialModal>
    </div>
  );
}

export default Modal;
